/* ------------------------------------------------------
   Original artists carousel
   Uses the theme's existing Swiper (window.Swiper).
   Auto-scrolls (autoplay), loops, pauses on hover.
------------------------------------------------------ */
(function () {
  function initArtists(root) {
    if (!root) return;
    var el = root.querySelector('[data-artists-swiper]');
    if (!el || el.dataset.inited) return;

    if (!window.Swiper) {
      // Theme's Swiper not ready yet — retry shortly.
      window.setTimeout(function () { initArtists(root); }, 100);
      return;
    }

    el.dataset.inited = 'true';

    new window.Swiper(el, {
      slidesPerView: 1.46,
      spaceBetween: 16,
      watchOverflow: true,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      navigation: {
        prevEl: root.querySelector('[data-artists-prev]'),
        nextEl: root.querySelector('[data-artists-next]')
      },
      breakpoints: {
        750: { slidesPerView: 2, spaceBetween: 20 },
        990: { slidesPerView: 3, spaceBetween: 24 }
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-artists]').forEach(initArtists);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when added/updated in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    initArtists(e.target.querySelector('[data-artists]'));
  });
})();